<script lang="ts">
    import { createEventDispatcher, get_current_component, onMount, set_input_type } from 'svelte/internal'
    import Fa from 'svelte-fa'
    import { faAngleLeft, faEdit, faPlusCircle, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    // ##############################################################################################################
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Zact from '../../_common/z/zact.svelte'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import { Account } from '../../../modules/financialApi/accounts/account'
    import { AccountTypeEnum } from '../../../modules/financialApi/accounts/account.enum'
    import type { CreateAccountDto } from '../../../modules/financialApi/accounts/dto/create-account.dto'
    import type { UpdateAccountAccount } from '../../../modules/financialApi/accounts/dto/update-account.dto'
    import Content from '../../_common/content.svelte'
    const dispatch = createEventDispatcher()

    const entityId = 'accountId'

    export let accountId = null
    export let form: boolean = false
    export let bank: string = null

    let bancos = [
        { numero: '000', nome: 'Caixa interno / Tesouraria' },
        { numero: '001', nome: 'Banco do Brasil' },
        { numero: '033', nome: 'Santander' },
        { numero: '062', nome: 'Hipercard' },
        { numero: '070', nome: 'Banco de Brasília - BRB' },
        { numero: '077', nome: 'Banco Inter' },
        { numero: '085', nome: 'Viacredi' },
        { numero: '104', nome: 'Caixa Econômica Federal' },
        { numero: '212', nome: 'Banco Original' },
        { numero: '237', nome: 'Bradesco' },
        { numero: '260', nome: 'Nubank' },
        { numero: '318', nome: 'Banco BMG' },
        { numero: '336', nome: 'C6 Bank' },
        { numero: '341', nome: 'Itaú Unibanco' },
        { numero: '399', nome: 'HSBC Bank Brasil' },
        { numero: '422', nome: 'Banco Safra' },
        { numero: '623', nome: 'Banco PAN' },
        { numero: '633', nome: 'Banco Rendimento' },
        { numero: '637', nome: 'Banco Sofisa' },
        { numero: '655', nome: 'Banco Votorantim' },
        { numero: '756', nome: 'Banco Cooperativo do Brasil' },
        { numero: '9970', nome: 'Cartão de Crédito' },
        { numero: '9980', nome: 'Entradas e Saídas no PDV' },
        //{ numero: '9985', nome: 'Vendas no PDV' },
        { numero: '9999', nome: 'Outro' },
    ]
    if (bank) {
        bancos = [bancos.find((el) => el.numero === bank)]
    }

    const me = get_current_component()
    let show = false
    let step = 1
    let entities: Account[] = []
    let entity: Account = new Account()

    async function editEntity(id: string) {
        try {
            show = true
            entity = new Account()
            entity = await window.api.financials.accounts.getOne(id)
            console.log('account', entity)
            step = 2
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function newEntity() {
        entity = new Account()
        step = 2
    }

    function setType() {
        if (entity.bank === '000') {
            entity.type = AccountTypeEnum.local
        } else if (entity.bank === '9980') {
            entity.type = AccountTypeEnum.pos
        } else if (entity.bank === '9985') {
            entity.type = AccountTypeEnum.sys
        } else {
            entity.type = AccountTypeEnum.bank
        }
    }

    async function createEntity() {
        try {
            show = true
            setType()
            const dto: CreateAccountDto = {
                label: entity.label,
                type: entity.type,
                account: entity.account,
                bank: entity.bank,
                branch: entity.branch,
                source: entity.source,
            }
            entity = await window.api.financials.accounts.create(dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function sendClose() {
        dispatch('close')
    }

    async function updateEntity() {
        try {
            show = true
            setType()
            const dto: UpdateAccountAccount = {
                label: entity.label,
                type: entity.type,
                account: entity.account,
                bank: entity.bank,
                branch: entity.branch,
                source: entity.source,
            }
            await window.api.financials.accounts.update(entity[entityId], dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function saveEntity() {
        if (entity[entityId]) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    async function loadEntities() {
        try {
            show = true
            step = 1
            entities = await window.api.financials.accounts.getAll()
            entities = entities
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Contas bancárias'
        grid.subtitle = ''
        grid.fontSize = '15px'
        grid.cols.push(new GridCol({ content: 'Nome da conta', type: GridColTypeEnum.string, maxLength: 45 }))
        grid.cols.push(new GridCol({ content: 'Banco' }))
        grid.cols.push(new GridCol({ content: 'Agência' }))
        grid.cols.push(new GridCol({ content: 'Conta' }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            const btnEdit = new GridButton({
                callback: () => editEntity(item.accountId),
                icon: faEdit,
                label: 'Editar',
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.label })
            line.slots.push({ content: item.bank })
            line.slots.push({ content: item.branch })
            line.slots.push({ content: item.account })
            line.slots.push({ content: [btnEdit] })
            grid.lines.push(line)
        }
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir esta conta?')) {
            return
        }
        try {
            show = true
            await window.api.financials.accounts.remove(entity[entityId])
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        step = 1
    }

    onMount(async () => {
        await loadEntities()
        if (form) {
            if (accountId) {
                await editEntity(accountId)
            } else {
                newEntity()
            }
        }
    })
</script>

<Content>
    {#if step === 1}
        <Zact>
            <div class="spacer" />
            <button class="btn btn-primary" on:click={newEntity}><Fa icon={faPlusCircle} /> Nova conta</button>
        </Zact>
        <Zgrid class="mt-3" {grid} />
    {/if}
    {#if step === 2}
        <Zact>
            {#if !form}
                <button class="btn btn-secondary" on:click={showEntities}><Fa icon={faAngleLeft} /> Voltar</button>
            {/if}
            <div class="spacer" />
            {#if !!entity.accountId}
                <button class="btn btn-warning me-1" on:click={removeEntity}><Fa icon={faTrashAlt} /> Excluir</button>
            {/if}
            <button class="btn btn-primary" on:click={saveEntity}><Fa icon={faSave} /> Salvar</button>
        </Zact>

        <Zframe title="Conta bancária" class="mt-3">
            <div class="grid-form">
                <div class="row">
                    <div class="col">
                        <div class="input-group">
                            <label for="" class="input-group-text">Nome da conta</label>
                            <input type="text" bind:value={entity.label} class="form-control" />
                        </div>
                    </div>
                    <div class="col">
                        <div class="input-group">
                            <label for="" class="input-group-text">Banco</label>
                            <select class="form-select" bind:value={entity.bank} name="" id="">
                                {#each bancos as banco}
                                    <option value={banco.numero}>{banco.nome + ' - ' + banco.numero}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                </div>
                {#if entity.bank !== '000' && entity.bank !== '9980' && entity.bank !== '9985'}
                    <div class="row">
                        <div class="col">
                            <div class="input-group">
                                <label for="" class="input-group-text">Agência (sem o dígito)</label>
                                <input type="text" bind:value={entity.branch} class="form-control" />
                            </div>
                        </div>
                        <div class="col">
                            <div class="input-group">
                                <label for="" class="input-group-text">Conta (com o dígito)</label>
                                <input type="text" bind:value={entity.account} class="form-control" />
                            </div>
                        </div>
                        <div class="col">
                            <div class="input-group input-group">
                                <label for="" class="input-group-text">Origem dos dados</label>
                                <select class="form-select" bind:value={entity.source}>
                                    <option value="manual">digitação</option>
                                    <option value="ofx">Arquivo OFX</option>
                                    <option value="auto">Open Finance</option>
                                </select>
                            </div>
                        </div>
                    </div>
                {/if}
            </div>
        </Zframe>
    {/if}
</Content>

<style>
</style>
